import React, { useState, useEffect } from 'react';
import { FaStar, FaChevronLeft, FaChevronRight, FaQuoteLeft } from 'react-icons/fa';

const TestimonialCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

  const testimonials = [
    {
      id: 1,
      image: "01",
      name: "Sophia Anne Harris",
      position: "Property Manager at Green Valley Realty",
      text: "From the initial consultation to the final walk-through, every step was handled with the utmost professionalism and care. Their team listened closely to our needs and created a plan that fit our vision perfectly, all while keeping us within budget and on schedule.",
      rating: 4.8
    },
    {
      id: 2,
      image: "06",
      name: "Alena Joe Harris",
      position: "Property Manager at Green Valley Realty",
      text: "The team's commitment to quality and timely delivery was impressive. The end result exceeded our expectations and left our clients thrilled with their new space. Omanye provided exceptional guidance and craftsmanship, creating a building we are proud to call ours.",
      rating: 4.8
    },
    {
      id: 3,
      image: "07",
      name: "Michael Thompson",
      position: "CEO at Horizon Builders",
      text: "Working with Omanye was a game-changer for our project. Their innovative ideas, attention to detail, and seamless execution ensured everything was delivered to the highest standards. We couldn’t have asked for a better partner.",
      rating: 5.0
    }
  ];

  // Handle next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  // Handle previous slide
  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  // Go to specific slide
  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  // Auto-play functionality
  useEffect(() => {
    let interval;
    if (isAutoPlaying) {
      interval = setInterval(() => {
        nextSlide();
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoPlaying, currentIndex]);

  return (
    <div className="py-4 bg-black relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-1/2 bg-gradient-to-b from-[#00A3A1] to-transparent opacity-10"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 rounded-full bg-[#00A3A1] opacity-5 blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-4">
          <span className="text-[#00A3A1] font-medium mb-2 block">Client's Feedback</span>
          <h2 className="text-4xl font-bold text-white">
            What Our Clients Say After Getting Our Services
          </h2>
        </div>

        {/* Carousel container */}
        <div
          className="relative max-w-5xl mx-auto"
          onMouseEnter={() => setIsAutoPlaying(false)}
          onMouseLeave={() => setIsAutoPlaying(true)}
        >
          {/* Navigation arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-12 z-10 bg-[#00A3A1] hover:bg-teal-600 text-white p-3 rounded-full shadow-lg transition-all duration-300"
            aria-label="Previous testimonial"
          >
            <FaChevronLeft className="text-lg" />
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-12 z-10 bg-[#00A3A1] hover:bg-teal-600 text-white p-3 rounded-full shadow-lg transition-all duration-300"
            aria-label="Next testimonial"
          >
            <FaChevronRight className="text-lg" />
          </button>

          {/* Testimonial cards */}
          <div className="overflow-hidden">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentIndex * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div
                  key={testimonial.id}
                  className="flex-shrink-0 w-full px-4"
                >
                  <div className="bg-gray-900 p-8 rounded-xl h-full border border-gray-800 hover:border-[#00A3A1] transition-all duration-300 group">
                    {/* Quote icon */}
                    <div className="text-[#00A3A1] mb-6">
                      <FaQuoteLeft className="text-3xl opacity-80" />
                    </div>

                    <p className="text-gray-300 italic mb-8 text-lg leading-relaxed group-hover:text-white transition-colors duration-300">
                      "{testimonial.text}"
                    </p>

                    {/* <div className="flex flex-col sm:flex-row items-center justify-between pt-6 border-t border-gray-800">
                      <div className="flex items-center mb-4 sm:mb-0">
                        <div className="relative">
                          <div className="absolute -inset-1 bg-[#00A3A1] rounded-full opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>
                          <img
                            src={`/assets/images/testimonials/${testimonial.image}.webp`}
                            alt={testimonial.name}
                            className="w-14 h-14 rounded-full object-cover relative z-10"
                          />
                        </div>
                        <div className="ml-4">
                          <h5 className="font-bold text-white">{testimonial.name}</h5>
                          <span className="text-gray-400 text-sm">{testimonial.position}</span>
                        </div>
                      </div>

                      <div className="text-center sm:text-right">
                        <div className="stars flex justify-center sm:justify-end text-yellow-400 mb-1">
                          {[...Array(5)].map((_, i) => (
                            <FaStar
                              key={i}
                              className={i < Math.floor(testimonial.rating) ? "text-yellow-400" : "text-gray-600"}
                            />
                          ))}
                        </div>
                        <p className="text-sm font-bold text-white">
                          {testimonial.rating}
                          <span className="text-gray-400 font-normal"> Ratings</span>
                        </p>
                      </div>
                    </div> */}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Dots indicator */}
          <div className="flex justify-center mt-10 space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-3 w-3 rounded-full transition-all duration-300 ${currentIndex === index
                  ? 'bg-[#00A3A1] w-8'
                  : 'bg-gray-700 hover:bg-gray-500'
                  }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCarousel;